import { useApiGetPenilaianCountDinas } from 'api/kinerja/kepala-sekolah/dinas/penilaian'
import { useApiGetPenilaianCountDinasTabGuru } from 'api/kinerja/kepala-sekolah/guru/dinas/penilaian'

const usePenetapanCountDinas = ({ enabled = false }: { enabled: boolean }) => {
  const { data: { data: counterKs } = {}, isLoading: isLodingCountKs } =
    useApiGetPenilaianCountDinas({
      enabled,
    })

  const { data: { data: counterGuru } = {}, isLoading: isLodingCountGuru } =
    useApiGetPenilaianCountDinasTabGuru({
      enabled,
    })

  return {
    isLoading: isLodingCountKs || isLodingCountGuru,
    data: {
      belumDikirim:
        parseInt(`${counterKs?.belumDikirim || 0}`, 10) +
        parseInt(`${counterGuru?.belumDikirim || 0}`, 10),
      sudahDikirim:
        parseInt(`${counterKs?.sudahDikirim || 0}`, 10) +
        parseInt(`${counterGuru?.sudahDikirim || 0}`, 10),
      all:
        parseInt(`${counterKs?.all || 0}`, 10) +
        parseInt(`${counterGuru?.all || 0}`, 10),
    },
  }
}

export default usePenetapanCountDinas
